import { ESubIds, subIds } from '~/types/GioNode';

/**
 * package => numberOfMonths
 */
export type RewardPeriodType = {
  [key in (typeof subIds)[number]]: number;
};

export const rewardPeriods: RewardPeriodType = {
  [ESubIds.BASIC]: 18,
  [ESubIds.BASICP]: 60,
  [ESubIds.PREMIUM]: 36,
  [ESubIds.PREMIUMP]: 84,
  [ESubIds.MASTER]: 84,
  [ESubIds.MASTERP]: 180,
  [ESubIds.COLLECTOR]: 12,
  [ESubIds.VIP]: 12,
};

export const defaultNumberOfRewardDays = 365;
